"use client";
import { useEffect as r } from "react";
const n = (o, e) => {
  r(() => {
    if (e && e?.length > 1) {
      const { current: l } = o, t = l?.querySelector(e);
      t ? t.scrollIntoView({ behavior: "smooth" }) : document.body.scrollIntoView();
    } else
      document.body.scrollIntoView();
  }, [o, e]);
};
export {
  n as default
};
//# sourceMappingURL=index.es49.js.map
